function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { createContext, useContext, useEffect, useRef } from "react";
import { scrollToElement as defaultScrollToElement, DEFAULT_SCROLL_OFFSET, DEFAULT_VISIBILITY_THRESHOLD } from "./utils";
export var ScrollIntoViewContext = createContext(defaultScrollToElement);
export var scrollIntoViewDefaults = {
  offset: DEFAULT_SCROLL_OFFSET,
  visibilityThreshold: DEFAULT_VISIBILITY_THRESHOLD,
  always: false
};
export default function useScrollIntoView(options) {
  var _scrollIntoViewDefaul = _extends({}, scrollIntoViewDefaults, options),
      offset = _scrollIntoViewDefaul.offset,
      visibilityThreshold = _scrollIntoViewDefaul.visibilityThreshold,
      always = _scrollIntoViewDefaul.always;

  var ref = useRef(null);
  var scrollToElement = useContext(ScrollIntoViewContext);
  useEffect(function () {
    if (ref.current == null) return;
    scrollToElement(ref.current, {
      offset: offset,
      visibilityThreshold: visibilityThreshold,
      always: always
    });
  }, [scrollToElement, offset, visibilityThreshold, always]);
  return ref;
}